// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomToolbar_wrapper__DKwxg","helper":"CustomToolbar_helper__2Mt2O","emojiWrapper":"CustomToolbar_emojiWrapper__2FxlF"};